<template>
  <div >
    <!-- 정보를 확인해주는 아래쪽에 스낵바 띄우기 -->        
    <v-snackbar v-model="snackbar" :color="color" :timeout="timeout"> {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar = false" v-bind="attrs"><v-icon>close</v-icon></v-btn>
      </template>
    </v-snackbar>

    <!-- 에러를 나타내는 다이어로그 띄우기 -->   
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
          <v-card-title class="headline red--text"><div v-html="sTitle"></div></v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-5"><div v-html="sMsg"></div></v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="red darken-1" text @click="GoResult()" @keydown.enter="GoResult()"  class="font-weight-bold"><v-icon class="mr-2">check_circle</v-icon>확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>  
</template>


<script>
// 통신관련 메시지등을 표현할때 사용됨. (확인창만 존재)
  export default {
    data: () => ({
      snackbar: false,
      color: '',
      text: '----',
      timeout: 2000,
      dialog: false,
      sTitle: "",
      sMsg: "",
    }),     
    methods : {  
      GoResult: function() {
        this.dialog = false;

        // MsgBox를 다시 띄우지 못하게 
        this.justClosed = true;
        setTimeout(() => this.justClosed = false, 500);
      },
    
      //GoResult: function() {
      //  this.dialog = false;      
      //},

      //결과값 표기시 줄바꿈문자의 혼용을 html로 바꾸고 다이얼로그를 띄움 (태그에서 v-html로 받음)
      RunMsgBoxShow: function (sTitle, sMsg) {
        // 방금 닫힌 경우 무시
        if (this.justClosed) {
          return;
        }
        this.sTitle = sTitle.replace(/(?:\r\n|\r|\n)/g, "<br />");
        this.sMsg = sMsg.replace(/(?:\r\n|\r|\n)/g, "<br />");

        this.$nextTick(() => {
          // 150ms 정도 후에 dialog를 true로 설정
          setTimeout(() => {
            this.dialog = true;
          }, 150);
        });
      },

      // RunMsgBoxShow: function(sTitle, sMsg) {        
      //   this.sTitle = sTitle.replace(/(?:\r\n|\r|\n)/g, '<br />');
      //   this.sMsg = sMsg.replace(/(?:\r\n|\r|\n)/g, '<br />');
      //   this.dialog = true;
      // },

      //다이얼로그로 에러를 보여줌 (에러가 아닐시는 스낵바에 내용을 보여줌)
      //isErr과 sMsg는 이벤트버스로부터 받아옴 (true를 보낼시 에러를 의미함)
      //APP 화면띄울시 디폴트로 들어감
      ShowMsg: function(isErr, sMsg) {        
        var s = sMsg.toString(); 
        if (isErr === true) {
          this.color = "error"
          this.RunMsgBoxShow("Error", s);
        } else {
          this.color = "info"
          this.text = s;            
          this.snackbar = true;
        }
      },

      //결과값을 메세지박스로 보여줌 (다른곳에서 차용해서 쓰임, 다이얼로그 띄우기)
      ShowCommResult: function(sMsg) {        
        var s = sMsg.toString();
        this.color = "info"
        this.RunMsgBoxShow("Result", s);
      },
    } 
  }
</script>